import React from 'react';
import {Loader} from '@gravity-ui/uikit';
import styles from './PageLoader.module.scss';

interface PageLoaderProps {
  message?: string;
  size?: 's' | 'm' | 'l';
}

export const PageLoader: React.FC<PageLoaderProps> = ({size = 'l'}) => {
  return (
    <div className={styles.container}>
      <Loader size={size} />
    </div>
  );
};
